var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgH2O = function SvgH2O(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 347c0 90.981 74.019 165 165 165s165-74.019 165-165c0-37.354-12.832-74.96-36.138-104.052L211 82.006 82.138 242.948C58.832 272.04 46 309.646 46 347m90 0c0 41.353 33.647 75 75 75v30c-57.891 0-105-47.109-105-105zM391 196c41.353 0 75-33.647 75-75 0-17.241-5.669-33.428-16.392-46.802L391 0l-58.608 74.198C321.669 87.572 316 103.759 316 121c0 41.353 33.647 75 75 75"
  })));
};
export default SvgH2O;